
export default function AdditionalConsiderations() {
  const items = [
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity & HIPAA compliance',
      color: 'from-[#e10708] to-[#c00607]'
    },
    {
      icon: 'ri-mail-lock-line',
      title: 'Clinical Operations & Patient Flow',
      color: 'from-[#c00607] to-[#a00506]'
    },
    {
      icon: 'ri-computer-line',
      title: 'Staffing & Training',
      color: 'from-[#a00506] to-[#e10708]'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Revenue Cycle & Financial Pressures',
      color: 'from-[#e10708] to-[#c00607]'
    },
    {
      icon: 'ri-user-search-line',
      title: 'Phones, Communication & Patient Experience',
      color: 'from-[#c00607] to-[#a00506]'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Vendor Management & Coordination',
      color: 'from-[#a00506] to-[#e10708]'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-gray-50 to-red-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#e10708] to-[#c00607] rounded-full mb-6">
            <i className="ri-alert-line text-3xl text-white"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Additional Critical Items to Consider
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Beyond the core infrastructure, these security and compliance elements are essential for protecting your practice and patients.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-red-200 group"
            >
              <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 leading-snug">
                {item.title}
              </h3>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl shadow-xl p-10 border-2 border-red-200">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0 w-12 h-12 bg-[#e10708] rounded-lg flex items-center justify-center">
              <i className="ri-lightbulb-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Ready to Build Your Practice the Right Way?
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Whether you're launching a new practice or expanding to multiple locations, we're here to ensure your technology foundation supports your clinical mission. Let's discuss your specific needs and create a customized plan for your success.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}